import { SharpieImageConfig } from './useSharpie';

export const heroImageConfig: SharpieImageConfig = {
  desktop: {
    width: 1500,
    height: 400,
  },
  smallDesktop: {
    width: 540,
    height: 390,
  },
  tablet: {
    width: 768,
    height: 240,
  },
  mobile: {
    width: 375,
    height: 220,
  },
};

export const mostPopularImageConfig = {
  width: 168,
  height: 96,
};

export const postCardImageConfig: SharpieImageConfig = {
  desktop: {
    width: 720,
    height: 400,
  },
  tablet: {
    width: 448,
    height: 250,
  },
  mobile: {
    width: 292,
    height: 220,
  },
};

export const newsGuidesDecorsImageConfig: SharpieImageConfig = {
  desktop: {
    width: 117,
    height: 88,
  },
  tablet: {
    width: 166,
    height: 125,
  },
  mobile: {
    width: 117,
    height: 88,
  },
};

export const heroVideoConfig: SharpieImageConfig = {
  desktop: {
    width: 1500,
    height: 840,
  },
  tablet: {
    width: 1536,
    height: 860,
  },
  mobile: {
    width: 750,
    height: 420,
  },
};

export const featuredVideosConfig: SharpieImageConfig = {
  desktop: {
    width: 168,
    height: 96,
  },
  tablet: {
    width: 224,
    height: 125,
  },
  mobile: {
    width: 168,
    height: 96,
  },
};

export const projectRelatedArticleImageConfig = {
  width: 200,
  height: 160,
};

export const recommendedImageConfig = {
  width: 720,
  height: 440,
};
